/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-background-color',
  templateUrl: './theme-option-datalabels-background-color.component.html',
  styleUrls: ['./theme-option-datalabels-background-color.component.css']
})
export class ThemeOptionDatalabelsBackgroundColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  backgroundColor: string;
  optionType: ThemeOptionType = 'datalabels_backgroundColor';

  constructor() {
    this.showDetails = false;
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.backgroundColor = this.themeOptions.datalabels(this.datalabelsIndex).backgroundColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.datalabels(this.datalabelsIndex).backgroundColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.backgroundColor = value;
    this.themeOptions.setDatalabels(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.datalabelsIndex);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setDatalabels(this.optionType, this.backgroundColor + Math.round(value * 255 / 100).toString(16), this.datalabelsIndex);
    }
    else {
      this.themeOptions.setDatalabels(this.optionType, this.backgroundColor + '00', this.datalabelsIndex);
    }
  }

}
